// extracted by mini-css-extract-plugin
export default {"textContainer":"TextInput_textContainer__xvME8","textInput":"TextInput_textInput__GlsSr"};